import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { LoggerService } from '../services/logger.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  const toastr = inject(ToastrService);

  return next(req).pipe(
    catchError((error) => {
      // Skip 401s — handled by authInterceptor
      if (error.status === 401) {
        return throwError(() => error);
      }

      // Log ALL non-401 errors via LoggerService
      logger.error(
        `HTTP ${error.status} ${req.method} ${req.url}`,
        error.error
      );

      // Toast user-friendly message for common error categories
      // The error is ALWAYS re-thrown so component-level handlers still fire.
      // Components with their own .subscribe({ error: ... }) will show their own toast.
      // Components WITHOUT an error handler will have this toast as the only user feedback.
      // ngx-toastr's preventDuplicates:true (configured in app.config.ts) prevents
      // double-toasting when both interceptor and component show the same message.
      const message = error.error?.message || getDefaultMessage(error.status);
      toastr.error(message);

      return throwError(() => error);
    })
  );
};

function getDefaultMessage(status: number): string {
  if (status === 0) return 'Unable to connect to the server. Please check your internet connection.';
  if (status === 403) return 'You do not have permission to perform this action.';
  if (status === 404) return 'The requested resource was not found.';
  if (status >= 500) return 'Something went wrong. Please try again later.';
  return 'Something went wrong.';
}
